import { ExpedienteDetailPage as SharedExpedienteDetailPage } from "@tribunalea/ui";
import { useApi } from "../App.jsx";

export function ExpedienteDetailPage({ identifier, sourceId }) {
  const api = useApi();
  return (
    <SharedExpedienteDetailPage
      api={api}
      backLabel="Buscar expedientes"
      backPath="/expedientes"
      basePath="/expedientes"
      identifier={identifier}
      productName="Instrumenta"
      readOnly
      sourceId={sourceId}
    />
  );
}
